import { useModal } from '@/customHooks/useModal'
import { EditItemListModal } from './modal/EditItemListModal'
import { useContext, useRef } from 'react'
import { SelectedItemContext } from '@/App'
import { SelectedItem } from '@/types/Types'
import itemListJson from '@/resources/itemShop.json'

const ItemListView = () => {
  // #region フック

  const selectedItem = useContext(SelectedItemContext)

  const addItemListModal = useModal()

  const editUuid = useRef('')

  // #endregion フック

  // #region スタイル

  const itemListAreaStyle: React.CSSProperties = {
    display: 'flex'
  }

  const itemListTableStyle: React.CSSProperties = {
    marginTop: 'auto',
    marginBottom: 'auto',
    marginLeft: '0',
    backgroundColor: '#FFFFFF',
    width: '650px',
    height: '300px',
    border: 'solid 1px',
    overflowY: 'scroll'
  }

  const buttonStyle: React.CSSProperties = {
    marginTop: '24px',
    marginLeft: '10px',
    display: 'flex',
    flexDirection: 'column'
  }

  const addButtonStyle: React.CSSProperties = {
    marginBottom: '10px'
  }

  // #endregion スタイル

  // #region イベント

  const onClickAddButton = () => {
    editUuid.current = ''
    addItemListModal.openModal()
  }

  const onClickClearButton = () => {
    const res = window.confirm('検索条件をクリアしてもよろしいですか？')
    if (res) {
      selectedItem.clear()
    }
  }

  // #endregion イベント

  return (
    <>
      <div style={itemListAreaStyle}>
        <div>
          お買い物リスト：
          <div style={itemListTableStyle}>
            <ItemListTableView
              selectedItem={selectedItem}
              editUuid={editUuid}
              addItemListModal={addItemListModal}
            />
          </div>
        </div>
        <div style={buttonStyle}>
          <button style={addButtonStyle} onClick={onClickAddButton}>
            追加
          </button>
          <button onClick={onClickClearButton}>クリア</button>
        </div>
        <EditItemListModal
          isOpen={addItemListModal.isOpen}
          closeModal={addItemListModal.closeModal}
          editUuid={editUuid.current}
        />
      </div>
      <h1>総費用：{selectedItem.getTotalCost().toLocaleString()} G</h1>
    </>
  )
}

export default ItemListView

type ItemListProps = {
  selectedItem: SelectedItem
  editUuid: React.MutableRefObject<string>
  addItemListModal: {
    isOpen: boolean
    openModal: () => void
    closeModal: () => void
  }
}

const ItemListTableView = ({ selectedItem, editUuid, addItemListModal }: ItemListProps) => {
  // #region スタイル

  const disabledFontStyle: React.CSSProperties = {
    textDecoration: 'line-through',
    color: '#808080'
  }

  // #endregion スタイル

  // #region イベント

  const onChangeCheckBox = (e: React.ChangeEvent<HTMLInputElement>) => {
    selectedItem.setEnabled(e.currentTarget.value, e.currentTarget.checked)
  }

  const onClickEditButton = (e: React.MouseEvent<HTMLButtonElement>) => {
    editUuid.current = e.currentTarget.value
    addItemListModal.openModal()
  }

  const onClickDeleteButton = (e: React.MouseEvent<HTMLButtonElement>) => {
    const res = window.confirm('指定したアイテムを削除してもよろしいですか？')
    if (res) {
      selectedItem.remove(e.currentTarget.value)
    }
  }

  // #endregion イベント

  const body = (
    <tbody>
      {selectedItem.shopItemList.map((s) => (
        <tr id={s?.uuid} key={s?.uuid}>
          <td>
            <input
              type='checkbox'
              name={s?.uuid}
              value={s?.uuid}
              checked={s?.enabled}
              onChange={onChangeCheckBox}
            />
          </td>
          <td style={s?.enabled === false ? disabledFontStyle : {}}>{s?.name}</td>
          <td style={s?.enabled === false ? disabledFontStyle : {}}>
            {`（1個当たり${itemListJson.itemShop.find((e) => e.name === s.name)?.price ?? 0}G）`}
          </td>
          <td style={s?.enabled === false ? disabledFontStyle : {}}>{s?.count}個</td>
          <td>
            <button value={s?.uuid} onClick={onClickEditButton}>
              編集
            </button>
          </td>
          <td>
            <button value={s?.uuid} onClick={onClickDeleteButton}>
              削除
            </button>
          </td>
        </tr>
      ))}
    </tbody>
  )

  return <table>{body}</table>
}
